<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
        <div class="row w-100 p-list-representation-province-main pr-4 pl-4">

          <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
                <cityAndProvince
                @selectedCity      = "selectedCity"
                @selectedProvince  = "selectedProvince"

                :update-city-selected="updateCitySelected"
                :citys             ="citys"
                :province-items    ="provinceItems"
                :city-selected     ="citySelected"
                :province-selected ="provinceSelected"
                ></cityAndProvince>
                <excelExportBtn :excel-data="excelData"></excelExportBtn>
          </div>

          <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
              <div class="row w-100 flex-column flex-lg-row">
                  <div class=" row flex-lg-row flex-column">

                    <div class="form-group d-flex flex-wrap ml-lg-4 mb-4 mb-lg-0">
                      <div class="row w-100 align-items-center ">
                        <label for="namyFamily " class="ml-lg-3 p-list-representation-label-text mb-lg-0 mb-2">نام و نام خانوادگی</label>
                        <input v-model="nameFamily"  type="text" class="form-control" id="namyFamily" placeholder="">
                      </div>
                    </div>

                    <div class="form-group  d-flex flex-wrap ml-lg-4 mb-4 mb-lg-0">
                      <div class="row w-100 align-items-center  ">
                        <label for="code " class="ml-lg-3 p-list-representation-label-text mb-lg-0 mb-2">کد ملی</label>
                        <input  v-model="nationalCode" type="text" class="form-control" id="code" placeholder="">
                      </div>
                    </div>

                  </div>

                  <div class="d-flex p-list-representation-btn-left justify-content-end flex-grow-1">
                    <button @click="searchTableRepresentation" type="button" class="p-list-representation-btn btn btn-primary btn-sm">جستجو</button>
                    <button @click="modalShowSelectFile" type="button" class="p-list-representation-btn btn btn-primary btn-sm mr-4">خروجی اکسل بانک</button>
                  </div>

              </div>


          </div>


        </div>



        <modalSelectFile :active.sync="statusShowModalSelectFile" @submitTransactionExcel="submitTransactionExcel"  />

        <modalTransactionRecord
         :active.sync="showModalTransactionRecord"
          @submitModalDataTransaction="submitModalDataTransaction"

          :click-btn-transaction-value-representation="clickBtnTransactionValueRepresentation"
          :loading-transaction-form="loadingTransactionForm"

            />

  </div>
</template>

<script>
import cityAndProvince from './cityAndProvince';
import excelExportBtn from './excelExportBtn';
import modalSelectFile  from './modalSelectFile';
import modalTransactionRecord from './modalTransactionRecord';


export default {
  name: "contentList",
  components: {
    cityAndProvince,
    excelExportBtn,
    modalSelectFile,
    modalTransactionRecord,
  },

  props: {
    citys                                      : {type:Array,default:[]},
    provinceItems                              : {type:Array,default:[]},
    excelData                                  : {type:Array,default:[]},
    statusShowTransactionRecord                : {type:Boolean,default:false},
    citySelected                               : {type:Object,default:{}},
    provinceSelected                           : {type:Object,default:{}},
    updateCitySelected                         : {type:Number,default:0},
    clickBtnTransactionValueRepresentation     : {type:Object,default:{}},
    loadingTransactionForm                     : {type:Boolean,default:false},

  },

  data() {
    return {
      statusShowModalSelectFile                : false,
      nameFamily                               : '',
      nationalCode                             : '',
      showModalTransactionRecord               : false,


    }
  },

  watch: {
    statusShowTransactionRecord(status){
      this.showModalTransactionRecord = status;
    },

    showModalTransactionRecord(status){
      console.log(status);
      this.$emit('updateStatusModalTransactionRecord',status);
    },


  },

  created() {

  },

  mounted() {
  },

  methods: {
    modalShowSelectFile(){
      this.statusShowModalSelectFile = true;
    },

    submitTransactionExcel(blob){
      console.log(blob,'selectedFileActive');
    },

    searchTableRepresentation(){
      const setDataNameAndCodeNatinal = {
        national_code : this.nationalCode,
        name          : this.nameFamily,
      }

      this.$emit('searchTableRepresentation',setDataNameAndCodeNatinal);
    },

    selectedCity(data){
      this.$emit('selectedCity',data);
    },

    selectedProvince(data){
      this.$emit('selectedProvince',data);
    },

    submitModalDataTransaction(data){
      this.$emit('submitModalDataTransaction',data)
    },




  }


}
</script>
